type FontStyle = {
  fontSize: string;
  fontWeight?: number;
  lineHeight?: string | number;
  letterSpacing?: string | number;
};

export interface Typography {
  heading1: FontStyle;
  heading2: FontStyle;
  subtitle: FontStyle;
  caption: FontStyle;
  captionMedium: FontStyle;
  captionSmallMedium: FontStyle;
  body: FontStyle;
  bodyMedium: FontStyle;
  bodyBold: FontStyle;
  bodyLarge: FontStyle;
  bodySmall: FontStyle;
  bodySmallMedium: FontStyle;
  bodySmallBold: FontStyle;
  bodySmallest: FontStyle;
  bodySmallestMedium: FontStyle;
  bodySmallestBold: FontStyle;
}

const bold = 700;
const medium = 500;
const regular = 400;
const lineHeight = 1.2;

export const typography: Typography = {
  heading1: {
    fontSize: '2rem',
    fontWeight: bold,
    lineHeight,
  },
  heading2: {
    fontSize: '1.5rem',
    fontWeight: bold,
    lineHeight,
  },
  subtitle: {
    fontSize: '1.125rem',
    fontWeight: bold,
    lineHeight,
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: regular,
    lineHeight,
  },
  captionMedium: {
    fontSize: '0.75rem',
    fontWeight: medium,
    lineHeight,
  },
  captionSmallMedium: {
    fontSize: '0.625rem',
    fontWeight: medium,
    lineHeight,
  },
  body: {
    fontSize: '1rem',
    fontWeight: regular,
    lineHeight: '1.4',
  },
  bodyMedium: {
    fontSize: '1rem',
    fontWeight: medium,
    lineHeight,
  },
  bodyBold: {
    fontSize: '1rem',
    fontWeight: bold,
    lineHeight,
  },
  bodyLarge: {
    fontSize: '1.125rem',
    fontWeight: regular,
    lineHeight,
  },
  bodySmall: {
    fontSize: '0.875rem',
    fontWeight: regular,
    lineHeight: '1.4',
  },
  bodySmallMedium: {
    fontSize: '0.875rem',
    fontWeight: medium,
    lineHeight,
  },
  bodySmallBold: {
    fontSize: '0.875rem',
    fontWeight: bold,
    lineHeight,
  },
  bodySmallest: {
    fontSize: '0.625rem',
    fontWeight: regular,
    lineHeight: '1.4',
  },
  bodySmallestMedium: {
    fontSize: '0.625rem',
    fontWeight: medium,
    lineHeight: '1.4',
  },
  bodySmallestBold: {
    fontSize: '0.625rem',
    fontWeight: bold,
    lineHeight: '1.4',
  },
};
